import "react-intl-tel-input/dist/main.css";

import moment from "moment";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import IntlTelInput from "react-intl-tel-input";
import { Link, useNavigate } from "react-router-dom";
import { MdError, MdCheckCircle } from "react-icons/md";
import { useCallback, useEffect, useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  login,
  getCountries,
  getGlobalLanguages,
  getUserInformation,
  postSignUpAffiliate,
  // recaptchaValidate,
} from "../../store/middleware";
// import Checkbox from "../../components/Checkbox";
import Inputs from "../../components/Checkout/Inputs";
import Select from "../../components/Checkout/Select";
import NavBar from "../../components/Checkout/NavBar";
import { passwordValidator } from "../../utils/utils";
import { encryptValue } from "../../utils/fieldEncrypt";
import CardInfo from "../../components/affiliates/CardInfo";
import logoLingoPNG from "../../assets/images/lingo_small.png";

import {
  Container,
  Content,
  FormContainer,
  WrapperTitle,
  Title,
  Circle,
  Line,
  FormContent,
  WrapperInvalidPassword,
  ButtonNext,
  ButtonCloseModal,
  // WrapperTypePerson,
  // WrapperCheckboxInfluencer,
} from "./styles";

const keyRecaptcha = process.env.REACT_APP_KEY_RECAPTCHA;

function SignUpAffiliate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [password, setPassword] = useState("");
  // const [nickName, setNickName] = useState("");
  const [birthDate, setBirthDate] = useState(null);
  const [followingTotalAllPlatforms] = useState(0);
  const [considerYourselfInfluencer] = useState(false);
  const [nativeLanguageId, setNativeLanguageId] = useState(0);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const [userInfo, setUserInfo] = useState({});
  const [typePerson, setTypePerson] = useState(0);
  const [allCountries, setAllCountries] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [modalAlert, setModalAlert] = useState({ show: false, title: "", description: "", titleButton: "" });
  const [invalidPass, setInvalidPassword] = useState([
    { id: 1, message: "INVALID_PASS1", status: null },
    { id: 2, message: "INVALID_PASS2", status: null },
    { id: 3, message: "INVALID_PASS3", status: null },
    { id: 4, message: "INVALID_PASS4", status: null },
    { id: 5, message: "INVALID_PASS5", status: null },
  ]);

  const loadInfos = async () => {
    let languageURL = queryString.parse(window?.location.search)?.lang?.toLowerCase();

    if (languageURL === "en" || languageURL === "pt" || languageURL === "es" || languageURL === "fr") {
      await i18n.changeLanguage(languageURL);
    } else {
      await i18n.changeLanguage("en");
    }

    setTypePerson(0);
    dispatch(getCountries()).then((res) => setAllCountries(res));
    dispatch(getGlobalLanguages()).then((res) => setGlobalLanguages(res));

    let responseIPAPI = await dispatch(getUserInformation());
    responseIPAPI.country = responseIPAPI.country?.toLowerCase();
    setUserInfo(responseIPAPI);
  };

  const handleLogin = async () => {
    await dispatch(login({ strategy: "lingo", email: email.toLowerCase().trim(), password })).catch(() =>
      navigate("/login"),
    );
  };

  const validationAge = (value) => {
    const today = moment();
    const birthDate = moment(value, "YYYY-MM-DD");

    const age = today.diff(birthDate, "years");

    return age >= 18;
  };

  const validateForms = () => {
    if (name.trim() === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: typePerson === 0 ? "INVALID_FORM_CHECKOUT1" : "INVALID_FORM_CHECKOUT9",
      });

      return false;
    } else if (email.trim() === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT2",
      });

      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT3",
      });

      return false;
    } else if (phone === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT4",
      });

      return false;
    } else if (birthDate === null && typePerson === 0) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT10",
      });

      return false;
    } else if (!validationAge(birthDate) && typePerson === 0) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT11",
      });

      return false;
    } else if (country === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT5",
      });

      return false;
    } else if (nativeLanguageId === 0) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT12",
      });

      return false;
    } else if (considerYourselfInfluencer === "" && typePerson === 0) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "Influencer checkbox is required",
      });

      return false;
    } else if (followingTotalAllPlatforms === 0 && typePerson === 0 && considerYourselfInfluencer) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "The total following across all platforms is required",
      });

      return false;
    } else if (invalidPass.find((item) => item.status === null)) {
      const message = invalidPass.find((item) => item.status === null).message;
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: message,
      });

      return false;
    } else if (recaptchaValue === null) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT13",
      });

      return false;
    } else return true;
  };

  const handleSubmitCreateAccount = async (e) => {
    e.preventDefault();

    if (validateForms()) {
      let body = {
        name: name.trim(),
        // nickname: nickName.trim(),
        countryId: Number(country),
        timezone: userInfo?.timezone,
        tokeRecaptcha: recaptchaValue,
        nativeLanguageId: Number(nativeLanguageId),
        userPhones: [{ phone, userPhoneTypeId: 3 }],
        email: encryptValue(email.toLowerCase().trim()),
        userPassword: { password: encryptValue(password) },
      };

      if (typePerson === 0) {
        body.birthDate = moment(birthDate).format("YYYY-MM-DD");
        body.considerYourselfInfluencer = considerYourselfInfluencer;
        body.followingTotalAllPlatforms = Number(followingTotalAllPlatforms);
      } else if (typePerson === 1) {
        body.considerYourselfInfluencer = false;
        body.followingTotalAllPlatforms = 0;
      }

      await dispatch(postSignUpAffiliate(body))
        .then((resp) => resp && handleLogin())
        .catch((error) => {
          const message = error?.response?.data?.error;

          if (message.includes("account registered!")) {
            sessionStorage.setItem("@rememberEmail", email);
            setModalAlert({
              show: true,
              titleButton: "BTN_LOGIN",
              title: "INVALID_FORM_TITLE",
              description: `${t("INVALID_FORM_CHECKOUT7")} ${email} ${t("INVALID_FORM_CHECKOUT7_1")}`,
            });
          } else {
            setModalAlert({
              show: true,
              description: message,
              titleButton: "BTN_CLOSE",
              title: "INVALID_FORM_TITLE",
            });
          }
        });
    }
  };

  const renderInputPhone = () => {
    return (
      <IntlTelInput
        inputClassName="form-control"
        containerClassName="intl-tel-input"
        defaultCountry={userInfo?.country}
        style={{ marginBottom: 15, zIndex: 100, width: "105%" }}
        onPhoneNumberChange={(_, value, countryData, number) => {
          console.log(value, countryData); //nao remover

          const numberFormatted = number.replace(/\D/g, "");
          setPhone(`+${numberFormatted}`);
        }}
      />
    );
  };

  const checkPassword = useCallback(
    async (e, type) => {
      if (type === "password") setPassword(e.target.value);
      else if (type === "confirmation") setPasswordConfirmation(e.target.value);

      setInvalidPassword(passwordValidator(password, passwordConfirmation));
    },
    [password, passwordConfirmation],
  );

  const handleCloseModalAlert = () => setModalAlert((state) => ({ ...state, show: false }));

  const onChangeRecaptcha = async (value) => {
    setRecaptchaValue(value);
    // await dispatch(recaptchaValidate(value));
  };

  useEffect(() => {
    if (password) checkPassword();
  }, [password, passwordConfirmation, checkPassword]);

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <NavBar title="AFFILIATE" description="AFFILIATE" />

      <Content>
        <FormContainer>
          <WrapperTitle>
            <Circle>
              <img src={logoLingoPNG} />
            </Circle>
            <Title>{t("CREATE_YOUR_ACCOUNT")}</Title>
          </WrapperTitle>

          <div>
            <Line />

            <FormContent>
              {/* <WrapperTypePerson>
                <Checkbox label={t("PHYSICAL_PERSON")} checked={typePerson === 0} onChange={() => setTypePerson(0)} />
                <Checkbox label={t("LEGAL_PERSON")} checked={typePerson === 1} onChange={() => setTypePerson(1)} />
              </WrapperTypePerson> */}

              {typePerson === 0 ? (
                <>
                  <Inputs
                    type="text"
                    value={name}
                    autoComplete="off"
                    label={t("NAME_FULL")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setName(target.value)}
                  />
                  {/* <Inputs
                    type="text"
                    value={nickName}
                    autoComplete="off"
                    label="Nick Name"
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setNickName(target.value)}
                  /> */}
                  <Inputs
                    type="email"
                    value={email}
                    autoComplete="off"
                    label={t("EMAIL")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setEmail(target.value)}
                  />

                  {renderInputPhone()}

                  <input className="inputAutoCompleteEmail" />

                  <Inputs
                    type="date"
                    value={birthDate}
                    label={t("BIRTH_DATE")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setBirthDate(target.value)}
                    max={moment().subtract(18, "years").format("YYYY-MM-DD")}
                  />
                  <Select
                    width="105"
                    label={t("COUNTRY")}
                    options={allCountries}
                    labelSelect={t("SELECT")}
                    style={{ marginBottom: 15 }}
                    onChange={({ target }) => setCountry(target.value)}
                  />
                  <Select
                    width="105"
                    labelSelect={t("SELECT")}
                    options={globallanguages}
                    label={t("NATIVE_LANGUAGE")}
                    style={{ marginBottom: 45 }}
                    onChange={({ target }) => setNativeLanguageId(target.value)}
                  />

                  {/* <WrapperCheckboxInfluencer mb={considerYourselfInfluencer.toString()}>
                    <label>Do you consider yourself an influencer?</label>
                    <Checkbox
                      label={t("BTN_YES")}
                      checked={considerYourselfInfluencer === true}
                      onChange={() => setConsiderYourselfInfluencer(true)}
                    />
                    <Checkbox
                      label={t("BTN_NO")}
                      checked={considerYourselfInfluencer === false}
                      onChange={() => setConsiderYourselfInfluencer(false)}
                    />
                  </WrapperCheckboxInfluencer>

                  {considerYourselfInfluencer && (
                    <Inputs
                      type="number"
                      autoComplete="off"
                      style={{ marginBottom: 37 }}
                      value={followingTotalAllPlatforms}
                      label="What is your total following across all platforms?"
                      onChange={({ target }) => setFollowingTotalAllPlatforms(target.value)}
                    />
                  )} */}

                  <input className="inputAutoCompleteEmail" />

                  <Inputs
                    password
                    value={password}
                    autoComplete="off"
                    label={t("PASSWORD")}
                    showPassword={showPassword}
                    style={{ marginBottom: 37 }}
                    onBlur={() => checkPassword()}
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => checkPassword(e, "password")}
                    onClickPassword={() => setShowPassword(!showPassword)}
                  />
                  <Inputs
                    password
                    autoComplete="off"
                    style={{ marginBottom: 37 }}
                    value={passwordConfirmation}
                    label={t("PASSWORD_CONFIRM")}
                    onBlur={() => checkPassword()}
                    showPassword={showPasswordConfirmation}
                    onChange={(e) => checkPassword(e, "confirmation")}
                    type={showPasswordConfirmation ? "text" : "password"}
                    onClickPassword={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                  />
                </>
              ) : (
                <>
                  <Inputs
                    type="text"
                    value={name}
                    autoComplete="off"
                    label={t("CORPORATE_NAME")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setName(target.value)}
                  />
                  {/* <Inputs
                    type="text"
                    value={nickName}
                    autoComplete="off"
                    label="Nick Name"
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setNickName(target.value)}
                  /> */}
                  <Inputs
                    type="email"
                    value={email}
                    autoComplete="off"
                    label={t("EMAIL")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setEmail(target.value)}
                  />

                  {renderInputPhone()}

                  <input className="inputAutoCompleteEmail" />

                  <Select
                    width="105"
                    label={t("COUNTRY")}
                    options={allCountries}
                    style={{ marginBottom: 15 }}
                    labelSelect={t("SELECT_COUNTRY")}
                    onChange={({ target }) => setCountry(target.value)}
                  />
                  <Select
                    width="105"
                    labelSelect={t("SELECT")}
                    options={globallanguages}
                    style={{ marginBottom: 50 }}
                    label={t("COMMUNICATION_LANGUAGE")}
                    onChange={({ target }) => setNativeLanguageId(target.value)}
                  />

                  <Inputs
                    password
                    value={password}
                    autoComplete="off"
                    label={t("PASSWORD")}
                    showPassword={showPassword}
                    style={{ marginBottom: 37 }}
                    onBlur={() => checkPassword()}
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => checkPassword(e, "password")}
                    onClickPassword={() => setShowPassword(!showPassword)}
                  />
                  <Inputs
                    password
                    autoComplete="off"
                    style={{ marginBottom: 37 }}
                    value={passwordConfirmation}
                    label={t("PASSWORD_CONFIRM")}
                    onBlur={() => checkPassword()}
                    showPassword={showPasswordConfirmation}
                    onChange={(e) => checkPassword(e, "confirmation")}
                    type={showPasswordConfirmation ? "text" : "password"}
                    onClickPassword={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                  />
                </>
              )}

              <WrapperInvalidPassword>
                {invalidPass &&
                  invalidPass.map((message, index) =>
                    message.status === null || message.status === false ? (
                      <div key={index}>
                        <MdError size={16} color="#979797" />
                        <p>
                          {t(message.message)} {message.id === 4 && "Ex: @#!$%^&*()-"}
                        </p>
                      </div>
                    ) : (
                      <div key={index}>
                        <MdCheckCircle size={16} color="#3cacfc" />
                        <p style={{ color: "#3cacfc" }}>
                          {t(message.message)} {message.id === 4 && "Ex: @#!$%^&*()-"}
                        </p>
                      </div>
                    ),
                  )}
              </WrapperInvalidPassword>

              <ReCAPTCHA sitekey={keyRecaptcha} onChange={(value) => onChangeRecaptcha(value)} />

              <ButtonNext onClick={handleSubmitCreateAccount}>{t("BTN_NEXT")}</ButtonNext>
            </FormContent>
          </div>
        </FormContainer>

        <CardInfo />
      </Content>

      <Dialog
        className="boxModal"
        open={modalAlert.show}
        onClose={handleCloseModalAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal" style={{ marginBottom: -5 }}>
            {t(modalAlert.title)}
          </span>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{t(modalAlert.description)}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            {modalAlert.titleButton === "BTN_LOGIN" ? (
              <Link to="/login">
                <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
              </Link>
            ) : modalAlert.titleButton === "BACK" ? (
              <a rel="noreferrer" href="https://www.lingofor.me/lingo-us/lingo_plans.html" target="_top">
                <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
              </a>
            ) : (
              <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default SignUpAffiliate;
